import styled from 'styled-components';

export const PatientsPageContainer = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: ${(props) =>
    props.isOpen ? 'minmax(250px, 350px) 1fr' : '1fr'};
  gap: 30px;
  height: calc(100vh - 48px);
  overflow: auto;
`;
